module.exports = __webpack_public_path__ + "r-v3/img/ml_41_01.274b5038.jpg";